import { Component, OnDestroy } from '@angular/core';

import { AlertService, MessageSeverity, DialogType } from '../../services/alert.service';
import { AccountService } from "../../services/account.service";
import { NGXLogger } from 'ngx-logger';
import { Subscription } from 'rxjs';
import { Utilities } from '../../services/utilities';

@Component({
    selector: 'forgot-password',
    template: require('./forgot-password.component.html'),
    styles: [require('./forgot-password.component.css')]
})
export class ForgotPasswordComponent implements OnDestroy {

    private subscribers: Subscription[] = [];
    email: string = '';
    isLoading = false;
    isMailSent = false;

    constructor(private alertService: AlertService, private accountService: AccountService, private ngxLogger: NGXLogger) {

    }

    ngOnDestroy() {
        if (this.subscribers) {
            this.subscribers.forEach(s => s.unsubscribe());
        }
    }

    forgotPassword() {
        this.isLoading = true;

        const sendResetLinkSubscriber = this.accountService.sendPasswordResetlink(this.email).subscribe((res) => {
            this.isLoading = false;
            this.isMailSent = true;
            
        }, error => {

            this.isLoading = false;
            this.isMailSent = false;
            this.ngxLogger.error(error.message);
            

            let errorMessage = Utilities.findHttpResponseMessage("error_description", error);

            if (errorMessage)
                this.alertService.showStickyMessage("Waarschuwing", errorMessage, MessageSeverity.warn, error);
            else
                this.alertService.showStickyMessage("Fout", "Er is een fout opgetreden.Probeer het later nogmaals.\nError: " + error.statusText || error.status, MessageSeverity.error, error);

            });

        this.subscribers.push(sendResetLinkSubscriber);
        
    }

    showErrorAlert(caption: string, message: string) {
        this.alertService.showMessage(caption, message, MessageSeverity.error);
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/forgot-password/forgot-password.component.ts